import React, { useState, useEffect } from 'react';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const LocationSelector = ({ 
  location, 
  onLocationChange, 
  error,
  className = '' 
}) => {
  const [isDetecting, setIsDetecting] = useState(false);
  const [detectionError, setDetectionError] = useState('');

  const handleAutoDetect = () => {
    setIsDetecting(true);
    setDetectionError('');

    // Simulate geolocation detection
    setTimeout(() => {
      const mockLocations = [
        { city: 'New York', state: 'NY', zipCode: '10001', lat: 40.7128, lng: -74.0060 },
        { city: 'Los Angeles', state: 'CA', zipCode: '90210', lat: 34.0522, lng: -118.2437 },
        { city: 'Chicago', state: 'IL', zipCode: '60601', lat: 41.8781, lng: -87.6298 },
        { city: 'Houston', state: 'TX', zipCode: '77001', lat: 29.7604, lng: -95.3698 },
        { city: 'Phoenix', state: 'AZ', zipCode: '85001', lat: 33.4484, lng: -112.0740 }
      ];
      
      const randomLocation = mockLocations?.[Math.floor(Math.random() * mockLocations?.length)];
      
      onLocationChange({
        ...location,
        city: randomLocation?.city,
        state: randomLocation?.state,
        zipCode: randomLocation?.zipCode,
        coordinates: {
          lat: randomLocation?.lat,
          lng: randomLocation?.lng
        }
      });
      
      setIsDetecting(false);
    }, 2000);
  };

  const handleInputChange = (field, value) => {
    onLocationChange({
      ...location,
      [field]: value
    });
  };

  return (
    <div className={`space-y-4 ${className}`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <Icon name="MapPin" size={20} className="text-primary" />
          <h3 className="text-lg font-semibold text-foreground">Affected Location</h3>
        </div>
        
        <Button
          variant="outline"
          size="sm"
          onClick={handleAutoDetect}
          loading={isDetecting}
          iconName="Crosshair"
          iconPosition="left"
          disabled={isDetecting}
        >
          {isDetecting ? 'Detecting...' : 'Auto-detect'}
        </Button>
      </div>
      {detectionError && (
        <div className="flex items-center space-x-2 p-3 bg-error/10 border border-error/20 rounded-md">
          <Icon name="AlertCircle" size={16} className="text-error" />
          <span className="text-sm text-error">{detectionError}</span>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label="City"
          type="text"
          placeholder="Enter city name"
          value={location?.city || ''}
          onChange={(e) => handleInputChange('city', e?.target?.value)}
          required
          className="w-full"
        />
        
        <Input
          label="State"
          type="text"
          placeholder="Enter state"
          value={location?.state || ''}
          onChange={(e) => handleInputChange('state', e?.target?.value)}
          required
          className="w-full"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Input
          label="ZIP Code"
          type="text"
          placeholder="Enter ZIP code"
          value={location?.zipCode || ''}
          onChange={(e) => handleInputChange('zipCode', e?.target?.value)}
          required
          className="w-full"
        />
        
        <Input
          label="Street Address (Optional)"
          type="text"
          placeholder="Enter street address"
          value={location?.address || ''}
          onChange={(e) => handleInputChange('address', e?.target?.value)}
          className="w-full"
        />
      </div>
      {error && (
        <div className="flex items-center space-x-2 p-3 bg-error/10 border border-error/20 rounded-md">
          <Icon name="AlertCircle" size={16} className="text-error" />
          <span className="text-sm text-error">{error}</span>
        </div>
      )}
    </div>
  );
};

export default LocationSelector;